export default __webpack_public_path__ + "static/media/notCompleted.15428c1d.png";